export default __webpack_public_path__ + "static/media/Teachers.0c24eb35.PNG";